import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useMemo,
  useState
} from "react";

import { DateRangeValueType } from "@audit-log/models";

export interface IAuditLogContext {
  dateRangeFilter?: DateRangeValueType;
  setDateRangeFilter: Dispatch<SetStateAction<DateRangeValueType>>;
}

export const AuditLogContext = createContext<IAuditLogContext>({
  dateRangeFilter: undefined,
  setDateRangeFilter: () => {}
});

export const AuditLogContextProvider = ({ children }) => {
  const [filter, setFilter] = useState<DateRangeValueType | undefined>();

  const value = useMemo(() => {
    return {
      dateRangeFilter: filter,
      setDateRangeFilter: setFilter
    };
  }, [filter]);

  return (
    <AuditLogContext.Provider value={value}>
      {children}
    </AuditLogContext.Provider>
  );
};

export const useAuditLogContext = () => useContext(AuditLogContext);
